import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import InputElement         from 'react-input-mask';
import FieldError           from '../Fragments/FieldError';

let Quote = require('../Managers/Quote.js');
let Validation = require('../Managers/Validation.js');

class SortcodeInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeValue: props.defaultValue ? props.defaultValue : null,
        };
    }

    componentWillMount() {
        if (!window.uornorb(this.props.defaultValue)) {
            this.setState({
                firstChunk: this.props.defaultValue.substring(0,2),
                secondChunk: this.props.defaultValue.substring(2,4),
                thirdChunk: this.props.defaultValue.substring(4,6),
            });
        } else {
            this.setState({
                firstChunk: null,
                secondChunk: null,
                thirdChunk: null,
            });
        }
    }

    /**
     * Gives focus to the next field in the series when the maximum field length
     * is reached.
     *
     * @param e
     */
    checkMoveToNextField(e) {
        if (e.target.value.length == 2) {
            document.getElementById(e.target.dataset.next).focus();
        }
    }

    handleValidation() {
        let validation = Validation.validate(this.props.dataValidation, this.state.sortcodeFull)[0];
        this.setState(validation);
        this.props.isValid(validation.isValid);
    }

    /**
     * Keeps track of the compound sortcode value in string format, then stashes
     * it into localStorage if all three fields are completed.
     */
    updateFullValue() {
        let first = document.getElementById(this.props.fieldName + '-1').value;
        let second = document.getElementById(this.props.fieldName + '-2').value;
        let third = document.getElementById(this.props.fieldName + '-3').value;

        let sortcodeFull = first.toString() + second.toString() + third.toString();

        if (window.uornorb(sortcodeFull)) {
            Quote.deleteByPath(this.props.source + '.' + this.props.storageKey);
        } else {
            Quote.set(this.props.storageKey, sortcodeFull, this.props.source);
            Quote.setAnswer(this.props.storageKey, sortcodeFull);
        }

        this.setState({
            sortcodeFull: sortcodeFull,
            activeValue: {
                first,
                second,
                third,
            }
        });
    }

    getCurrentValue() {
        return this.state.activeValue;
    }

    render() {
        return (
            <div className="question-input">
                <div className="row-3 constrained-row with-dividers">
                    <div className="column">
                        <InputElement
                            name={this.props.fieldName + '-1'}
                            id={this.props.fieldName + '-1'}
                            mask="99"
                            maskChar={null}
                            onKeyUp={this.checkMoveToNextField.bind(this)}
                            onBlur={this.updateFullValue.bind(this, 1)}
                            data-next={this.props.fieldName + '-2'}
                            defaultValue={this.state.firstChunk}
                        />
                    </div>

                    <div className="column divider">-</div>

                    <div className="column">
                        <InputElement
                            name={this.props.fieldName + '-2'}
                            id={this.props.fieldName + '-2'}
                            mask="99"
                            maskChar={null}
                            onKeyUp={this.checkMoveToNextField.bind(this)}
                            onBlur={this.updateFullValue.bind(this, 2)}
                            data-next={this.props.fieldName + '-3'}
                            defaultValue={this.state.secondChunk}
                        />
                    </div>

                    <div className="column divider">-</div>

                    <div className="column">
                        <InputElement
                            name={this.props.fieldName + '-3'}
                            id={this.props.fieldName + '-3'}
                            mask="99"
                            maskChar={null}
                            onBlur={this.updateFullValue.bind(this, 3)}
                            defaultValue={this.state.thirdChunk}
                        />
                    </div>
                </div>
                {this.state.hasError === true ?
                    <FieldError errors={this.state.errors} />
                :null}
            </div>
        );
    }
}

SortcodeInput.propTypes = {
    fieldName:      PropTypes.string.isRequired,
    storageKey:     PropTypes.string,
    helpText:       PropTypes.string,
    question:       PropTypes.string.isRequired,
    defaultValue:   PropTypes.object,
    dataValidation: PropTypes.string,
    source:         PropTypes.string,
    isValid:        PropTypes.func,
};

export default SortcodeInput;


// WEBPACK FOOTER //
// ./src/components/Fields/SortcodeInput.js